import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, mergeProps as _mergeProps, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34c3852c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper-input" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["name", "value"]
const _hoisted_4 = { class: "div-error" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputError = _resolveComponent("InputError")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", {
        for: _ctx.name,
        class: _normalizeClass({ 'input-focus': _ctx.inFocus || _ctx.filled ? true : false})
      }, _toDisplayString(_ctx.label), 11, _hoisted_2),
      _createElementVNode("input", _mergeProps({ name: _ctx.name }, _ctx.$attrs, {
        class: "input-base",
        value: _ctx.modelValue,
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
        onFocus: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.focusInput && _ctx.focusInput(...args))),
        onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.outFocusInput && _ctx.outFocusInput(...args)))
      }), null, 16, _hoisted_3)
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _createVNode(_component_InputError, { msg: _ctx.errors }, null, 8, ["msg"])
    ], 512), [
      [_vShow, _ctx.isInvalid]
    ])
  ]))
}